import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import BearerboxStoreTable from './BearerboxStoreTable';

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  main: {
    padding: theme.spacing(5)
  },
  button: {
    paddingLeft: 30,
  },
  footer: {
    padding: theme.spacing(3, 2),
    marginTop: "auto",
  }
}));

function BearerBoxStoreDrawer({ onClose, storeStatus }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6">STORE STATUS</Typography>
        </Toolbar>
      </AppBar>
      <div className={classes.main}>
        <BearerboxStoreTable storeStatus={storeStatus} />
      </div>
      <footer className={classes.footer}>
        <div className={classes.button}>
          <Button
            color={"primary"}
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </footer>
    </div>
  );
};

export default BearerBoxStoreDrawer;

